//Import required modules
import React from 'react';
import PropTypes from 'prop-types'

import {changeViz} from '../../store/actions'

const SimulateBtn = (props, {store}) =>
{
    let theme = store.getState().theme;
    let chartSelected = store.getState().chartSelected;
    return (
    <span>
        <i className={`fa fa-bar-chart btn-chart ${theme} ${chartSelected==='bar'?'active':'inactive'}`}
            onClick={() => store.dispatch(changeViz('bar'))}
            title='Bar chart'></i>
        <i className={`fa fa-pie-chart btn-chart ${theme} ${chartSelected==='pie'?'active':'inactive'}`}
            onClick={() => store.dispatch(changeViz('pie'))}
            title='Pie chart'></i>
        {/* <i className={`fa fa-line-chart btn-chart ${theme} ${chartSelected==='line'?'active':'inactive'}`}
            onClick={() => store.dispatch(changeViz('line'))}></i> */}
    </span>
    )
}

SimulateBtn.contextTypes = {
    store: PropTypes.object
}

export default SimulateBtn